export default '00000000-0000-0000-0000-000000000000';


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/node_modules/uuid/dist/esm-browser/nil.js